import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import { clearString } from "../../../utils/functions";
import { automaticApi } from "../../../settings/api";

export interface Fetch {
    document: string;
    phone?: string;
    email?: string;
    name?: string;
    callback: (success: boolean, errorMessage?: string) => void;
}

export interface SendPinRegisterAction {
    type: string;
    payload: Fetch;
}

export default function* sendPinRegister({
    payload,
}: SendPinRegisterAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const data = {
            actionId: 1019,
            cpfCnpj: clearString(payload.document),
            numeroCelular: payload?.phone ? clearString(payload.phone) : undefined,
            email: payload?.email ?? undefined,
            nomeCliente: payload?.name ?? undefined,
        };
        const response = yield call(automaticApi.post, `/pedido/v1/enviaPin`, data);

        if (response?.data?.status?.codigoRetorno === 0) {
            yield call(payload.callback, true);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}